import React from "react";


export default function Discover() {
  return (
    <div>Discover</div>
  )
}